import { CircleX } from 'lucide-react';
import { Button, EmptyState, Spinner } from '@elbklar/ui';
import { useAuth } from './AuthContext';

export function AuthCallbackPage() {
  const { error } = useAuth();

  // The AuthContext handles the OAuth callback automatically
  // This page just shows a loading state while processing

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <EmptyState
          icon={CircleX}
          title="Anmeldung fehlgeschlagen"
          description={error}
          action={
            <Button asChild variant="primary" size="lg">
              <a href="/login">Zurück zur Anmeldung</a>
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3 p-8 text-center">
        <Spinner size={28} />
        <p className="text-muted-foreground">Anmeldung wird verarbeitet …</p>
      </div>
    </div>
  );
}
